import {
  Component,
  HostBinding,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';

/**
 * The load panel: a white round pane with the load indicator, centered in the
 * positioned parent, optionally on a light shade that blocks the content below.
 * With `showElapsed` a slow search shows its elapsed time below the pane.
 */
@Component({
  selector: 'app-load-panel',
  template: `<div class="load-panel-pane">
      <mat-progress-spinner
        mode="indeterminate"
        [diameter]="32"
        [strokeWidth]="4"
      ></mat-progress-spinner>
    </div>
    @if (showElapsed) {
      <app-search-elapsed></app-search-elapsed>
    }`,
  styleUrls: ['./load-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LoadPanelComponent {
  @HostBinding('class.shading') @Input() shading = true;
  @Input() showElapsed = false;
}
